import { IApplicationState } from '../../types/redux';
import { EPageType } from '../../types/redux/page';

export const selectDealType = (state: IApplicationState) => state.page.dealType;
export const selectValuationType = (state: IApplicationState) => state.page.queryParams.valuationType;
export const selectQueryParams = (state: IApplicationState) => state.page.queryParams;
export const selectOfferId = (state: IApplicationState) => state.page.queryParams.offerId;
export const selectEstimationId = (state: IApplicationState) => state.page.queryParams.estimationId;
export const selectPageType = (state: IApplicationState) => state.page.pageType;
export const selectDeviceType = (state: IApplicationState) => state.page.deviceType;
export const selectIsCalculatorPage = (state: IApplicationState) => state.page.pageType === EPageType.Calculator;
export const selectIsReportReadyPage = (state: IApplicationState) => state.page.pageType === EPageType.ReportReady;
export const selectIsWebview = (state: IApplicationState) => state.page.isWebview;
export const selectIsStickyFooterVisible = (state: IApplicationState) => state.page.stickyFooterVisible;
export const selectPageCta = (state: IApplicationState) => state.page.cta;
export const selectIsFromOfferCard = (state: IApplicationState) => state.page.isFromOfferCard;
export const selectIsMyHome = (state: IApplicationState) => state.page.isFromMyHome;
export const selectMyHomeId = (state: IApplicationState) => state.page.queryParams.myHome;
export const selectIsDesktop = (state: IApplicationState) => state.page.deviceType === 'desktop';
export const selectCategory = (state: IApplicationState) => state.page.queryParams.category;
export const selectUtmCampaign = (state: IApplicationState) => state.page.queryParams.utmCampaign;
